// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable complexity */
/* eslint-disable max-lines */
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Optional,
  Output,
  Self,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControlName,
  NgControl
} from '@angular/forms';

@Component({
  selector: 'idp-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent implements ControlValueAccessor, OnChanges {
  @ViewChild('inputReference')
  inputReference!: ElementRef;

  @Input() ariaLabel = '';
  @Input() arrowPosition = 'right';
  @Input() checked = false;
  @Input()
  defaultValue!: string;

  @Input() disabled = false;
  @Input() error = false;
  @Input()
  errorMessage!: string;

  @Input() errorMessages: { [key: string]: string } = {};
  @Input() formControlName: any;
  @Input() icon = false;
  @Input()
  id!: string;

  @Input()
  name!: string;

  @Input() resetForm = false;
  @Input() showFormGrouped = true;
  @Input() submitAttempt = false;
  @Input()
  text!: string;

  @Input()
  value!: string;

  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Output() interaction: EventEmitter<any> = new EventEmitter<any>();
  @Output() radioFocus: EventEmitter<boolean> = new EventEmitter<boolean>();

  elementType = 'radio';
  focused = false;
  labelTxt!: string;
  showErrorToolTip = false;

  private onChange!: (item: {
    id: string;
    type?: string;
    value: string | false;
  }) => void;

  private onTouched!: () => void;

  constructor(
    private cdr: ChangeDetectorRef,
    @Optional() @Self() private ngControl: NgControl,
    @Optional() private controlName: FormControlName
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  get errorState(): boolean | null {
    if (
      this.ngControl &&
      this.ngControl.errors &&
      this.ngControl.touched &&
      this.submitAttempt &&
      Object.keys(this.errorMessages).length
    ) {
      this.errorMessage =
        this.errorMessages[Object.keys(this.ngControl.errors)[0]];
    }
    return (
      this.ngControl &&
      this.ngControl.errors &&
      this.ngControl.touched &&
      this.submitAttempt
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['text'] && !this.ariaLabel) {
      this.labelTxt = changes['text'].currentValue;
    }

    if (changes && changes['ariaLabel']) {
      this.labelTxt = changes['ariaLabel'].currentValue;
    }
  }

  writeValue(obj: any) {
    if (this.resetForm) {
      this.defaultValue = obj;
      this.inputReference.nativeElement.checked = obj;
    } else {
      if (obj) {
        this.defaultValue = obj;
        if (
          this.inputReference &&
          this.inputReference.nativeElement &&
          this.inputReference.nativeElement.id
        ) {
          if (obj.id === this.inputReference.nativeElement.id) {
            this.inputReference.nativeElement.checked = obj;
          }
        }
      }
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: any) {
    this.disabled = isDisabled;
  }

  notify(event: any) {
    this.clicked.emit(event);
    if (this.onChange) {
      this.onChange({
        id: this.id,
        type: this.elementType,
        value: this.inputReference.nativeElement.checked ? this.value : false
      });
    }
  }

  setFocused() {
    this.focused = true;
    if (this.onTouched) {
      this.onTouched();
    }
  }

  setInputFocus() {
    this.focused = true;
    if (this.submitAttempt) {
      this.showErrorToolTip = true;
    }
    if (
      (this.error || this.errorState) &&
      this.submitAttempt &&
      this.showErrorToolTip
    ) {
      this.radioFocus.emit(this.showErrorToolTip);
    }
  }

  focusOut() {
    this.focused = false;
    this.showErrorToolTip = false;
    this.cdr.detectChanges();
  }
}
